import React from 'react';
import './partners_carousel.scss';
import Flickity from 'react-flickity-component';

const PartnersCarousel = () => {
  const flickityOptions = {
    autoPlay: false,
    pauseAutoPlayOnHover: true,
    wrapAround: true,
    draggable: true,
    contain: true,
    groupCells: true,
    pageDots: false,
  };

  return (
    <div>
      <Flickity
        className={'carousel'} // default ''
        elementType={'div'} // default 'div'
        options={flickityOptions} // takes flickity options {}
        disableImagesLoaded={false} // default false
        reloadOnUpdate // default false
        static // default false
      >
        <div className="card">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://acherontrading.com/"
          >
            <div className="circle c_a"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_b"
            rel="noreferrer"
            href="https://acherontrading.com/"
          >
            acherontrading.com
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.chainenable.com/"
          >
            <div className="circle c_b"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_c"
            rel="noreferrer"
            href="https://www.chainenable.com/"
          >
            chainenable.com
          </a>
        </div>
        <div className="card">
          <a target="_blank" rel="noreferrer" href="https://www.finance.vote/">
            <div className="circle c_c"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_b"
            rel="noreferrer"
            href="https://www.finance.vote/"
          >
            finance.vote
          </a>
          <a target="_blank" rel="noreferrer" href="https://nexusmutual.io/">
            <div className="circle c_d"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_c"
            rel="noreferrer"
            href="https://nexusmutual.io/"
          >
            nexusmutual.io
          </a>
        </div>
        <div className="card">
          <a target="_blank" rel="noreferrer" href="https://rarestone.capital/">
            <div className="circle c_e"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_b"
            rel="noreferrer"
            href="https://rarestone.capital/"
          >
            rarestone.capital
          </a>
          <a target="_blank" rel="noreferrer" href="https://www.sushi.com/">
            <div className="circle c_f"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_c"
            rel="noreferrer"
            href="https://www.sushi.com/"
          >
            sushi.com
          </a>
        </div>
        <div className="card">
          <a target="_blank" rel="noreferrer" href="https://www.trustology.io/">
            <div className="circle c_g"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_b"
            rel="noreferrer"
            href="https://www.trustology.io/"
          >
            trustology.io
          </a>
          <a target="_blank" rel="noreferrer" href="https://www.zokyo.io/">
            <div className="circle c_h"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_c"
            rel="noreferrer"
            href="https://www.zokyo.io/"
          >
            zokyo.io
          </a>
        </div>
        <div className="card">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://acherontrading.com/"
          >
            <div className="circle c_a"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_b"
            rel="noreferrer"
            href="https://acherontrading.com/"
          >
            acherontrading.com
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.chainenable.com/"
          >
            <div className="circle c_b"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_c"
            rel="noreferrer"
            href="https://www.chainenable.com/"
          >
            chainenable.com
          </a>
        </div>
        <div className="card">
          <a target="_blank" rel="noreferrer" href="https://www.finance.vote/">
            <div className="circle c_c"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_b"
            rel="noreferrer"
            href="https://www.finance.vote/"
          >
            finance.vote
          </a>
          <a target="_blank" rel="noreferrer" href="https://nexusmutual.io/">
            <div className="circle c_d"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_c"
            rel="noreferrer"
            href="https://nexusmutual.io/"
          >
            nexusmutual.io
          </a>
        </div>
        <div className="card">
          <a target="_blank" rel="noreferrer" href="https://rarestone.capital/">
            <div className="circle c_e"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_b"
            rel="noreferrer"
            href="https://rarestone.capital/"
          >
            rarestone.capital
          </a>
          <a target="_blank" rel="noreferrer" href="https://www.sushi.com/">
            <div className="circle c_f"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_c"
            rel="noreferrer"
            href="https://www.sushi.com/"
          >
            sushi.com
          </a>
        </div>
        <div className="card">
          <a target="_blank" rel="noreferrer" href="https://www.trustology.io/">
            <div className="circle c_g"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_b"
            rel="noreferrer"
            href="https://www.trustology.io/"
          >
            trustology.io
          </a>
          <a target="_blank" rel="noreferrer" href="https://www.zokyo.io/">
            <div className="circle c_h"></div>
          </a>
          <a
            target="_blank"
            className="App_carousel_buttons_c"
            rel="noreferrer"
            href="https://www.zokyo.io/"
          >
            zokyo.io
          </a>
        </div>
      </Flickity>
    </div>
  );
};

export default PartnersCarousel;
